import React from "react";

/**
 * A string-based filter component for table columns.
 *
 * TanStack-Filters are defined in Table.
 *
 * @param column TanStack TanStack column variable
 * @param hoverText Optional string displayed when hovering over the input field
 */
const ClientStringFilter = ({ column, hoverText = "" }) => {
  return (
    <input
      type="text"
      className={
        "w-100 h-100 px-2 rounded-pill " + // layout
        "bg-transparent " + // color
        "border-0 " // border
      }
      style={{ fontSize: "15px" }} // font
      placeholder="Suche..."
      value={column.getFilterValue() || ""}
      onChange={(e) => column.setFilterValue(e.target.value)}
      title={hoverText}
    />
  );
};

export default ClientStringFilter;
